export default __webpack_public_path__ + "static/media/One-click.794fd3c4.jpg";